import AuthenticationProviderType from '../enums/authenticationProviderType';

const formatAuthenticationProvider = function(authenticationProvider) {

    if(authenticationProvider.providerType.toLowerCase() == AuthenticationProviderType.Application.toLowerCase()){
        return authenticationProvider.providerType;
    }
    else{
        return `${authenticationProvider.providerType} (${authenticationProvider.name})`;
    }
};

export default formatAuthenticationProvider;


// WEBPACK FOOTER //
// ./src/services/formatters/authenticationProviderFormatter.js